<template>
  <button class="uk-button uk-button-default" type="button" tabindex="-1">
    <span :uk-icon="'icon: ' + icon"></span>
  </button>
</template>
<style lang="scss" scoped>
.uk-button {
  border: 0;
}
</style>
<script lang="ts">
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
export default class IconButton extends Vue {
  @Prop({ type: String, required: true }) icon = "";
}
</script>
